module.exports = __webpack_public_path__ + "images/icons_v2/credit-card-filled-95e3ef7b.svg";